module.exports = __webpack_public_path__ + "teenagersDesktop.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/ui/preview-popup/assets/teenagersDesktop.png
// module id = 1179
// module chunks = 10